"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgCloneSeries(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M19 9.01v9a2.001 2.001 0 01-1.851 1.994l-.15.005L7 20.001V21l-3-2 3-2v1l10 .01V10l2-.99zM15 14v2H9v-2h6zm2-11l3 2-3 2V6H7v8.01L5 15V6a2 2 0 011.85-1.994L7 4h10V3zm-2 8v2H9v-2h6zm0-3v2H9V8h6z" })));
}
exports.default = tombacIcon_1.default('CloneSeries')(SvgCloneSeries);
//# sourceMappingURL=CloneSeries.js.map